module.exports = __webpack_public_path__ + "img/Right.892e0aaf.png";